import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { Col, Row, Result } from "../../components/UI/Layout";
import { Statistic, Card } from "../../components/UI/Layout";
import { resetPayment } from "../../store/payment";
import { Button } from "../../components/UI/Controls/Button";
import { PoslinkPayment } from "../Payment/PoslinkPayment";
import { DejavooPayment } from "../Payment/DejavooPayment";
import { addOrderPayment } from "../../store/order";

/**
 * @description The card step of checkout. Shows the amount being charged and
 * hands the sale to the terminal the station is provisioned with, chosen from
 * the station's own engine. A station carrying neither engine gets no charge
 * control and can only return to checkout.
 */
export const PaymentCard = (): JSX.Element => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {
    order,
    payment = { amount: 0 },
    loading,
    result,
    station,
  } = useAppSelector((state) => ({
    order: state.order,
    payment: state.payment.object,
    result: state.payment.result,
    station: state.store.station,
    loading: state.payment.loading,
  }));
  const { amount } = payment || { amount: 0 };
  const onBack = () => {
    navigate("/register/checkout");
  };

  useEffect(() => {
    if (order && order._id) {
      navigate("/register/thankyou");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order]);

  useEffect(() => {
    if (result && result.amount) {
      addOrderPayment(result)(dispatch);
      navigate("/register/checkout");
      resetPayment()(dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result]);

  const { stationPaymentEngine: device = "" } = station || {};

  return (
    <div
      style={
        window.innerWidth > 600
          ? { margin: "16px 80px" }
          : { margin: "5px 5px" }
      }
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card>
            <Statistic
              valueStyle={{ color: "#3f8600" }}
              title="Payment Amount"
              style={{ flex: 1 }}
              value={amount}
              precision={2}
              prefix="$"
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={12} offset={6}>
          {device === "poslink" ? <PoslinkPayment /> : null}
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={12} offset={6}>
          {device === "dejavoo" ? <DejavooPayment /> : null}
        </Col>
      </Row>
      {result ? (
        <Result status="success" title="Successfully Purchased!" />
      ) : null}
      {!loading ? (
        <Button
          size="lg"
          style={{ bottom: 0, position: "absolute", marginBottom: "30px" }}
          onClick={onBack}
        >
          <ArrowLeftOutlined />
          &nbsp;Return to Checkout
        </Button>
      ) : null}
    </div>
  );
};
